import { gql, useQuery } from '@apollo/client';

export type ArcFeatureToggle = {
  __typename: 'arc_feature_toggles';
  environment: string;
  feature_id: number;
  is_enabled: boolean;
};

export type ArcFeature = {
  __typename: 'arc_features';
  feature_id: number;
  feature_name: string;
  arc_features_arc_feature_toggles: ArcFeatureToggle[];
};

export type ArcFeaturesQueryResult = {
  arc_features: ArcFeature[];
};
const ARCFeatureToggleQuery = gql`
  query ARCFeatureToggleQuery($env: String!, $featureId: Int!) {
    arc_features(where: { feature_id: { _eq: $featureId } }) {
      feature_id
      feature_name
      arc_features_arc_feature_toggles(where: { environment: { _eq: $env } }) {
        environment
        feature_id
        is_enabled
      }
    }
  }
`;

export default function useGetFeatureToggle(env: string = 'POC2', featureId: number) {
  const { data, loading, error } = useQuery<ArcFeaturesQueryResult>(ARCFeatureToggleQuery, {
    variables: { env, featureId }
  });

  return { data, loading, error };
}
